
import { RouterStore } from 'mobx-react-router'

const routingStore = new RouterStore()

export default routingStore


// WEBPACK FOOTER //
// ./src/stores/routingStore.js